import React from 'react';
import { roomBackdrop } from '../../utils/roomView';

/**
 * 🚪📷 HouseRoomView — the per-room backdrop layers (ROOM_CAMERA_SPEC §4;
 * full per-room recipes 09-15 pm). Renders the roomView.js descriptor list:
 * light pools, edge tints, shafts, vignettes — every room its own place.
 *
 * ⚠️ These layers paint OVER the page content, not behind it (root stacking
 * context, DOM order — AmbientLayer's §81-89 warning; z:-1 would vanish
 * under the body wallpaper). All translucency therefore lives in the layer
 * `opacity`, capped by roomView's FILM_CAP/ACCENT_CAP and pinned by
 * roomView.test.js — never raise an opacity here.
 *
 * The main room renders NOTHING (roomBackdrop → null): the banner art IS
 * the house view, and the trio layers (wash · glow · weather) carry its
 * mood. Static CSS only — transitions on opacity/background, no animated
 * blur/box-shadow (perf ledger), nothing per-frame.
 */
export default function HouseRoomView({ roomId, hour }) {
  const b = roomBackdrop(roomId, hour);
  if (!b) return null;
  return (
    <div aria-hidden="true" style={{ position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none' }}>
      {b.layers.map((l, i) => (
        <div
          key={`${roomId}-${i}`}
          style={{
            position: 'absolute', inset: 0,
            background: l.bg,
            opacity: l.opacity,
            transition: 'opacity 700ms ease, background 1400ms linear',
            pointerEvents: 'none',
          }}
        />
      ))}
    </div>
  );
}
